module.exports = __webpack_public_path__ + "img/pathology-diastema.eb87ea52.png";